let stateInit = localStorage.getItem("usuario");
export default (state = stateInit, action) => {
    switch(action.type){
        case 'setUsuario':
            if(action.payload)
                return {...action.payload};
            else{
                return null
            }
        default:
            return state
    }
}